import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@xo-union/tk-component-icons';
import { H3 } from '@xo-union/tk-ui-typography';
import styles from './full-page-modal-header.scss';

const FullPageModalHeader = ({ title, onClose }) => (
  <div className={styles.titleContainer}>
    <div className={styles.backIconContainer}>
      <Icon name="back" onClick={onClose} size="md" />
    </div>
    <H3 className={styles.heading}>{title}</H3>
  </div>
);

FullPageModalHeader.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string,
};

export default FullPageModalHeader;
